const SENSITIVE_KEY =
  /authorization|cookie|password|passcode|secret|token|api[-_]?key|credential|credit|card|cvv|iban|email|phone|telefono|cellulare|codice.?fiscale|fiscal.?code|form.?data|request.?body|response.?body/i;

export function cleanText(value: unknown, maxLength = 2_000) {
  const cleaned = String(value ?? "Unknown error")
    .replace(/Bearer\s+[A-Za-z0-9._~+/-]+=*/gi, "Bearer [REDACTED]")
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[REDACTED_EMAIL]")
    .replace(/\b[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]\b/gi, "[REDACTED_CF]")
    .replace(/\b(?:\+?39[ .-]?)?(?:\d[ .-]?){9,10}\b/g, "[REDACTED_PHONE]")
    .replace(/([?&](?:token|key|secret|password|code)=)[^&\s]+/gi, "$1[REDACTED]");
  return cleaned.length > maxLength
    ? `${cleaned.slice(0, maxLength)}…`
    : cleaned;
}

export function cleanMetadata(value: unknown, depth = 0): unknown {
  if (depth >= 4) return "[TRUNCATED]";
  if (value === null || value === undefined) return value ?? null;
  if (typeof value === "string") return cleanText(value, 1_000);
  if (typeof value === "number" || typeof value === "boolean") return value;
  if (Array.isArray(value)) {
    return value.slice(0, 20).map((item) => cleanMetadata(item, depth + 1));
  }
  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .slice(0, 40)
        .map(([key, nestedValue]) => [
          key,
          SENSITIVE_KEY.test(key)
            ? "[REDACTED]"
            : cleanMetadata(nestedValue, depth + 1),
        ])
    );
  }
  return cleanText(value, 1_000);
}
